/**
 * Persona tiles — composite scenes built around the core avatar.
 * Each is a standalone component; <NovaExpression> wires the wrapper class.
 */
import * as React from "react";

import { NovaCowgirl } from "./persona-cowgirl";
import { NovaFrozen } from "./persona-frozen";
import { NovaAdventurer } from "./persona-indy";
import { NovaDJ } from "./persona-dj";
import { NovaChef } from "./persona-chef";
import { NovaPainter } from "./persona-painter";
import { NovaSuperhero } from "./persona-superhero";
import { NovaDetective } from "./persona-detective";

export const NOVA_PERSONA_IDS = ["cowgirl", "frozen", "indy", "dj", "chef", "painter", "superhero", "detective"] as const;
export type NovaPersonaId = (typeof NOVA_PERSONA_IDS)[number];

export const NOVA_PERSONAS: Record<NovaPersonaId, React.ComponentType<{ className?: string }>> = {
  "cowgirl": NovaCowgirl,
  "frozen": NovaFrozen,
  "indy": NovaAdventurer,
  "dj": NovaDJ,
  "chef": NovaChef,
  "painter": NovaPainter,
  "superhero": NovaSuperhero,
  "detective": NovaDetective,
};

export { NovaCowgirl } from "./persona-cowgirl";
export { NovaFrozen } from "./persona-frozen";
export { NovaAdventurer } from "./persona-indy";
export { NovaDJ } from "./persona-dj";
export { NovaChef } from "./persona-chef";
export { NovaPainter } from "./persona-painter";
export { NovaSuperhero } from "./persona-superhero";
export { NovaDetective } from "./persona-detective";
